import * as React from 'react';
import { Props } from 'react';

import './DialogView.scss';
import i18next from 'i18next';

interface AnyQuestionsViewProps extends Props<AnyQuestionsView> {

}

export class AnyQuestionsView extends React.Component<AnyQuestionsViewProps> {
    render() {
        return (
            <div className='dialog-container'>
                <div className='any-dialog-client-message'>
                    {i18next.t('where_is_pizza')}
                </div>
                <div className='clearfix' />
                <div className='any-dialog-client-message'>
                    {i18next.t('moscow_art_theater_tickets')}
                </div>
                <div className='clearfix' />
                <div className='any-dialog-client-message'>
                    {i18next.t('flowers_delivery')}
                </div>
                <div className='clearfix' />
                <div className='any-dialog-client-message'>
                    {i18next.t('documents_child')}
                </div>
                <div className='clearfix' />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CleverBot/Home/Dialogs/AnyQuestionsView.tsx